:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  font: inherit;
  margin: 0;
  padding: 0;
  color: inherit;
}

:host {
  --ch-markdown-viewer-indicator-color: currentColor;
  --ch-markdown-viewer-inline-size: 1.125ch;
  --ch-markdown-viewer-block-size: 1em;
  display: grid;
  grid-auto-rows: max-content;
}

:host(.ch-markdown-viewer-show-indicator) .last-nested-child::after,
:host(.ch-markdown-viewer-show-indicator):empty::after {
  content: "";
  display: inline-flex;
  inline-size: var(--ch-markdown-viewer-inline-size);
  block-size: var(--ch-markdown-viewer-block-size);
  background-color: var(--ch-markdown-viewer-indicator-color);
  transform: translateY(0.125em);
  animation: twinkle 0.75s linear infinite;
}

ch-markdown-viewer-lit {
  display: contents;
}

.ch-markdown-table-column-start {
  text-align: start;
}

.ch-markdown-table-column-center {
  text-align: center;
}

.ch-markdown-table-column-end {
  text-align: end;
}

blockquote {
  margin-inline: 0;
}

hr {
  block-size: 1px;
  margin: unset;
  padding: unset;
  border: unset;
  background-color: currentColor;
}

table {
  overflow: auto;
  word-break: normal;
  border-spacing: 0px;
  border-collapse: collapse;
}

ch-code {
  --ch-code-indicator-color: var(--ch-markdown-viewer-indicator-color);
  --ch-code-inline-size: var(--ch-markdown-viewer-inline-size);
  --ch-code-block-size: var(--ch-markdown-viewer-block-size);
}

@keyframes twinkle {
  60% {
    opacity: 1;
  }
  75% {
    opacity: 0;
  }
}